export default {
  oauth: {
    test: 'https://ams-auth-us-test.tigerbrokers.net',
    production: ['https://oauth.tradeup.com']
  },
  stock: {
    test: 'https://stock-qa.qa.tigerbrokers.net',
    production: ['https://hq.tradeup.com']
  },
  trade: {
    test: 'https://api-dev.tigerfintech.com',
    production: ['https://api.tradeup.com']
  },
  omnibusTrade: {
    test: 'https://trade-test-us.tigerfintech.com',
    production: ['https://trade.tradeup.com']
  },
  virtualTrade: {
    test: 'https://virtual-trade-test.tigerfintech.com',
    production: ['https://virtual-trade.tradeup.com']
  },
  push: {
    test: 'https://alert.tradeup.com',
    production: ['https://push.tradeup.com']
  },
  option: {
    test: 'https://option-qa.qa.tigerbrokers.net',
    production: ['https://option.tradeup.com']
  },
  stockNews: {
    test: 'https://stock-news.laohu8.com',
    production: ['https://stock-news.laohu8.com']
  },
  activity: {
    test: 'https://activity-test.ihuhoo.com/activity-us',
    production: ['https://activity.tradeup.com/activity-us']
  },
  community: {
    test: 'https://community-server-us.tradeup.com',
    production: ['https://stock-community.tradeup.com']
  },
  portal: {
    test: ' https://tradeup-dev.tigerfintech.com',
    production: ['https://www.tradeup.com']
  },
  tcti: {
    test: 'https://tcti-dev.tigerfintech.com',
    production: ['https://tcti.tradeup.com']
  },
  tesseract: {
    test: 'https://tesseract-dev.ihuhoo.com',
    production: ['https://tesseract.tradeup.com']
  },
  tesseractHk: {
    test: 'https://tesseract-dev.ihuhoo.com',
    production: ['https://tesseract.tradeup.com']
  },
  futContract: {
    test: 'https://contract-qa.ftigers.cc',
    production: ['https://contract-tb.ftfast.com']
  },
  futNews: {
    test: 'https://quotes-qa.ftigers.cc',
    production: ['https://quotes-tb.ftfast.com']
  },
  guardian: {
    test: 'https://ams-auth-us-test.tigerbrokers.net',
    production: ['https://auth-guardian.tradeup.com']
  },
  customer: {
    test: 'https://ams-customer-us-test.tigerbrokers.net',
    production: ['https://customer.tradeup.com']
  },
  customerSupport: {
    test: 'https://ams-customer-us-test.tigerbrokers.net/support',
    production: ['https://customer.tradeup.com/support']
  },
  hqPerm: {
    test: 'https://hq-perm-dev.tigerfintech.com',
    production: ['https://hq-perm.tradeup.com']
  },
  newCommunity: {
    test: 'https://community-server-us.tradeup.com',
    production: ['https://community-server-us.tradeup.com']
  }
}
